<template>  
    <v-container fluid grid-list-md>
        
        <v-layout row wrap>          
            <v-flex xs12>
                <h1> Dashboard </h1>
            </v-flex>
                
        </v-layout>    
        

        <v-layout row wrap>
            <v-flex d-flex x12 md6 lg3>
                <profil-card></profil-card>
            </v-flex>
            
           
            <v-flex d-flex xs12 md6 lg4>
                <v-layout row wrap>
                    
                    <v-flex d-flex>
                        <marken-card v-bind:mk="board.marken" v-on:preFilterMarken = "preFilterMarken"></marken-card>
                    </v-flex>
                    <v-flex d-flex>
                        <firmen-card v-bind:fa="board.firmen" v-on:preFilterFirmen = "preFilterFirmen"></firmen-card>
                    </v-flex>
                    <v-flex d-flex>
                        <texte-card v-bind:mk="board.marken" v-on:preFilterMarken = "preFilterMarken"></texte-card>
                    </v-flex>
                </v-layout>
                   
            </v-flex>
                
            <v-flex d-flex xs12 md12 lg5>
                <error-card v-bind:err="board.errors" v-on:preFilterMarken = "preFilterMarken" v-on:preFilterFirmen="preFilterFirmen"></error-card>
            </v-flex>
            
       </v-layout>

    </v-container>
    
</template>

<script>


import markenCard from './markenCard.vue'
import firmenCard from './firmenCard.vue'
import texteCard from './texteCard.vue'
import errorCard from './errorCard.vue'
import profilCard from './profilCard.vue'

export default {
    
    mounted() {
        if (this.$store.getters.isAuth) {
           this.$store.dispatch('setBoard')
            
        }
    },
    components: {
        'marken-card': markenCard,
        'firmen-card': firmenCard,
        'texte-card': texteCard,
        'error-card': errorCard,
        'profil-card': profilCard
    },
    computed: {
        board: function() {
            return this.$store.getters.board
        },
        loading: function() {
            return this.$store.getters.loading
        }        
    },
    methods: {
        preFilterFirmen: function (arr) {
            if(arr.length > 0) {                
            
                this.$store.dispatch('setPreFilteredFirmen', arr)
                this.$router.push('/firmen')
            }
        },
        preFilterMarken: function (arr) {
            if(arr.length > 0) {                
            
                this.$store.dispatch('setPreFilteredMarken', arr)
                this.$router.push('/marken')
            }
        }
    }

    
}
</script>

<style>
    
    
</style>



// WEBPACK FOOTER //
// showBoard.vue?110a7072